import * as types from './actionTypes';
import { employeeService } from '../_services';

export function fetchEmployeeList() {
  return dispatch => {
    return employeeService
      .getAllEmployee()
      .then(payload => {
        dispatch(success(payload));
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };

  function success(payload) {
    return { type: types.FETCH_EMPLOYEE_LIST, payload: payload };
  }
  function failure(error) {
    return { type: types.FETCH_EMPLOYEE_LIST_FAILURE, error };
  }
}

export function updateDisplayEmployee(cond) {
  return dispatch => {
    return dispatch({ type: types.UPDATE_DISPLAY_EMPLOYEE, cond: cond });
  };
}
